<div class="app-custom-loader" *ngIf="upgrading" [ngClass]="colorApp">
    <div class="app-loader">
        <div class="loader"></div>
    </div>
</div>
